export const userRoles = {
  admin: 'Admin',
  manager: 'Manager',
};
